import { Controller } from '@hotwired/stimulus'

const FORMATS = ['badge', 'rating', 'carousel', 'wall']
const THEMES = ['light', 'dark']

// Должен совпадать с ClubWidgetPreview::SLUG_PLACEHOLDER: превью показывает
// клуб-витрину, а копируемый сниппет — плейсхолдер под клуб читателя.
const SLUG_PLACEHOLDER = 'YOUR-CLUB-SLUG'

// Акцент красит саму марку Padelmesh (она в currentColor), поэтому классы text-*.
const ACCENTS = {
  'cobalt': 'text-brand-cobalt',
  'orange': 'text-bg-orange',
  'deep-blue': 'text-bg-blue'
}

export default class WidgetKitController extends Controller {
  static targets = [
    'accent',
    'code',
    'option',
    'themeOption',
    'themed',
    'variant'
  ]

  connect() {
    this.format =
      this.pressedValue(this.optionTargets, 'widgetKitFormatParam') || 'badge'
    this.accentName =
      this.pressedValue(this.accentTargets, 'widgetKitAccentParam') || 'cobalt'
    this.themeName =
      this.pressedValue(this.themeOptionTargets, 'widgetKitThemeParam') ||
      'light'
    this.render()
  }

  select(event) {
    this.format = event.params.format
    this.render()
  }

  accent(event) {
    this.accentName = event.params.accent
    this.render()
  }

  theme(event) {
    this.themeName = event.params.theme
    this.render()
  }

  pressedValue(targets, datasetKey) {
    return targets.find(
      (target) => target.getAttribute('aria-pressed') === 'true'
    )?.dataset[datasetKey]
  }

  render() {
    const format = FORMATS.includes(this.format) ? this.format : 'badge'
    const theme = THEMES.includes(this.themeName) ? this.themeName : 'light'
    const accent = ACCENTS[this.accentName] ? this.accentName : 'cobalt'

    // Вариант widget-dark в tailwind.css цепляется за этот атрибут.
    this.element.dataset.widgetTheme = theme

    this.variantTargets.forEach((variant) => {
      variant.classList.toggle(
        'hidden',
        variant.dataset.widgetKitVariantParam !== format
      )
    })

    this.themedTargets.forEach((element) => {
      element.classList.remove(...Object.values(ACCENTS))
      element.classList.add(ACCENTS[accent])
    })

    this.togglePressed(this.optionTargets, 'widgetKitFormatParam', format, true)
    this.togglePressed(
      this.themeOptionTargets,
      'widgetKitThemeParam',
      theme,
      true
    )
    this.togglePressed(
      this.accentTargets,
      'widgetKitAccentParam',
      accent,
      false
    )

    this.updateCode(format, theme, accent)
  }

  // Кнопки формата и темы перекрашиваются целиком, у кружков акцента меняется
  // только обводка — свой цвет они обязаны сохранить.
  togglePressed(targets, datasetKey, value, fill) {
    targets.forEach((target) => {
      const isSelected = target.dataset[datasetKey] === value
      target.setAttribute('aria-pressed', String(isSelected))

      if (fill) {
        target.classList.toggle('border-brand-cobalt', isSelected)
        target.classList.toggle('bg-brand-cobalt', isSelected)
        target.classList.toggle('text-white', isSelected)
        target.classList.toggle('bg-white', !isSelected)
        target.classList.toggle('text-text-primary', !isSelected)
      } else {
        target.classList.toggle('border-text-primary', isSelected)
      }

      target.classList.toggle('border-transparent', !isSelected)
    })
  }

  updateCode(format, theme, accent) {
    if (!this.hasCodeTarget) return

    // Дефолт должен совпадать с widget_code в for_clubs.slim — он страхует
    // случай, когда JS не поднялся.
    this.codeTarget.textContent = [
      '<div class="padelmesh-widget"',
      `     data-club="${SLUG_PLACEHOLDER}"`,
      `     data-format="${format}"`,
      `     data-theme="${theme}"`,
      `     data-accent="${accent}"></div>`,
      '<script src="https://padelmesh.com/widget.js" async></script>'
    ].join('\n')
  }
}
